export const DEFAULT_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: '-description',
};

export const DEFAULT_PAGES_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: '-first_seen',
  filters: {
    source: null,
    status: null,
  },
};

export const FILES_TABLE_ACTIONS = {
  delete: 'delete',
  download: 'download',
} as const;

export const ONLINE_SOURCES_TABLE_ACTIONS = {
  delete: 'delete',
  activate: 'activate',
  deactivate: 'deactivate',
  settings: 'settings',
  start: 'start',
  cancel: 'cancel',
} as const;

export const ONLINE_SOURCE_PAGES_TABLE_ACTIONS = {
  activate: 'activate',
  deactivate: 'deactivate',
  view: 'view',
} as const;

export const CATALOGS_TABLE_ACTIONS = {
  view: 'view',
  enable: 'enable',
  disable: 'disable',
  delete: 'delete',
} as const;

export const DEFAULT_CATALOGS_PAGINATION_SETTINGS = {
  page: 1,
  pageSize: 25,
  ordering: 'name',
};

export const getDefaultCatalogDescription = (t: (key: string) => string) =>
  t('The default knowledge catalog shared with all team members in your organization.');
